const escapeCsvCell = (value) => {
  const normalized = String(value ?? "").replace(/\r?\n|\r/g, " ").trim();
  return `"${normalized.replace(/"/g, '""')}"`;
};

const toCsvRow = (cells) => cells.map(escapeCsvCell).join(",");

const getTimestamp = () => {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, "0");
  const dd = String(now.getDate()).padStart(2, "0");
  const hh = String(now.getHours()).padStart(2, "0");
  const min = String(now.getMinutes()).padStart(2, "0");
  return `${yyyy}${mm}${dd}_${hh}${min}`;
};

export const exportSectionsToCsv = ({ sections = [], fileNamePrefix = "Export" }) => {
  const validSections = sections.filter(
    (section) =>
      section &&
      Array.isArray(section.headers) &&
      section.headers.length > 0 &&
      Array.isArray(section.records)
  );

  if (validSections.length === 0) return false;

  const csvContent = validSections
    .map((section, index) => {
      const title = section.title || `Table ${index + 1}`;
      const lines = [toCsvRow([title]), toCsvRow(section.headers)];
      section.records.forEach((record) => lines.push(toCsvRow(record)));
      return lines.join("\n");
    })
    .join("\n\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${fileNamePrefix}_${getTimestamp()}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  return true;
};
